import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardGenerateOutboundFreezeTimeUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardGenerateOutboundFreezeTimeUX-div-0"
        style={{height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardGenerateOutboundFreezeTimeUX-div-1"
          style={{ marginBottom: "40px" }}>

          <FormGroup
            id="CardGenerateOutboundFreezeTimeUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardGenerateOutboundFreezeTimeUX-FormField-5"
              inline={true}>
              <div
                id="CardGenerateOutboundFreezeTimeUX-div-8"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateOutboundFreezeTimeUX-label-11">
                  Date
                </label>
                <DateTextBox
                  id="CardGenerateOutboundFreezeTimeUX-DateTextBox-12"
                  onChange={props.onChangeDate}
                  value={props.generateOutboundData?.freezeDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardGenerateOutboundFreezeTimeUX-FormField-6"
              inline={true}
              width="4">
              <div
                id="CardGenerateOutboundFreezeTimeUX-div-9"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateOutboundFreezeTimeUX-label-13">
                  Tasks
                </label>
                <Dropdown
                  fluid={true}
                  id="CardGenerateOutboundFreezeTimeUX-Dropdown-14"
                  name="task"
                  onChange={props.onChangeData}
                  options={props.taskOptions}
                  selection={true}
                  value={props.generateOutboundData?.task || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardGenerateOutboundFreezeTimeUX-FormField-7"
              inline={true}>
              <div
                id="CardGenerateOutboundFreezeTimeUX-div-10"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateOutboundFreezeTimeUX-div-15">
                  {props.generateButton}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardGenerateOutboundFreezeTimeUX-FormField-16"
              inline={true}>
              <div
                id="CardGenerateOutboundFreezeTimeUX-div-17"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateOutboundFreezeTimeUX-div-18">
                  {props.refreshButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardGenerateOutboundFreezeTimeUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.outboundList}
            id="CardGenerateOutboundFreezeTimeUX-Table-3"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
      </div>
    )
}


export default CardGenerateOutboundFreezeTimeUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:18:40 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"40px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.outboundList"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-Table-3"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 12,
      "name": "DateTextBox",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-DateTextBox-12"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.generateOutboundData?.freezeDate || \"\""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Tasks"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-Dropdown-14"
        },
        "name": {
          "type": "value",
          "value": "task"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.taskOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.generateOutboundData?.task || \"\""
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generateButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.refreshButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateOutboundFreezeTimeUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardGenerateOutboundFreezeTimeUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
